import { Helmet } from "react-helmet-async";
const LIFESTYLE =
  "https://images.unsplash.com/photo-1770920740001-6fdbe0d7b172?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjB0ZWElMjBuYXR1cmV8ZW58MHx8fHwxNzc3Mjg1NDI3fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <>
    <Helmet>
      <title>About Kratoven | Borneo Heritage</title>
      <meta
        name="description"
        content="Learn the story behind Kratoven and our premium Borneo kratom sourced from the Kalimantan rainforest."
      />
      <link rel="canonical" href="https://kratoven.com/about" />
    </Helmet>
    <div className="container-kv pt-32 pb-20" data-testid="about-page">
      <div className="overline mb-4">The Kratoven Story</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter mb-4 max-w-3xl">
        <em className="italic text-[#C8A97E]">Krato·ven</em>. <span className="text-[#A8A5A1]">noun.</span>
      </h1>
      <p className="text-lg text-[#A8A5A1] max-w-2xl mb-10 leading-relaxed">
        A modern contraction of <span className="text-[#C8A97E]">Kratom</span> +
        <span className="text-[#C8A97E]"> Heaven</span> — the pursuit of the finest leaf
        Borneo has ever produced, presented as it deserves.
      </p>

      <div className="grid md:grid-cols-2 gap-12 items-start">
        <div className="space-y-6 text-[#A8A5A1] leading-relaxed">
          <p>
            Kratoven was founded on a simple principle: the finest kratom in the world already
            exists — it just has to be treated with the reverence it deserves.
          </p>
          <p>
            Our harvest partners are multi-generational farmers in the Kalimantan rainforest, who have
            been working with Mitragyna speciosa for longer than any vendor on earth. We don't cut
            corners, we don't blend batches, and we don't hide lab results.
          </p>
          <p>
            Every gram is micro-milled in small runs, triple-tested for purity, and vacuum-sealed
            in signature matte-black foil pouches. What you open months later is identical to what left
            our facility.
          </p>
          <p>
            We built Kratoven for the ritualists — the morning meditators, the creative minds,
            the night-time-wind-down seekers who know that quality is non-negotiable.
          </p>
          <div className="border-l-2 border-[#C8A97E] pl-5 mt-10 font-serif text-xl italic text-[#F4F1ED]">
            "It's not kratom. It's Kratoven."
          </div>
        </div>
        <div className="aspect-[4/5] overflow-hidden">
          <img src={LIFESTYLE} alt="Kratoven ritual" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
    </>
  );
}
